export default "__VITE_ASSET__DEVrld1P__"